import * as React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";

import DevicesRoundedIcon from "@mui/icons-material/DevicesRounded";
import EdgesensorHighRoundedIcon from "@mui/icons-material/EdgesensorHighRounded";
import ViewQuiltRoundedIcon from "@mui/icons-material/ViewQuiltRounded";

const items = [
  {
    icon: <ViewQuiltRoundedIcon fontSize="large" />,
    title: "Get setup quickly",
    description:
      "Our experienced team can provide you quick and latest solutions.",
  },
  {
    icon: <EdgesensorHighRoundedIcon fontSize="large" />,
    title: "Built for collaboration",
    description:
      "We keep you updated throughout the development life cycle at all times by working together.",
  },
  {
    icon: <DevicesRoundedIcon fontSize="large" />,
    title: "Backed by an amazing team",
    description:
      "Our experienced team provides cutting edge solutions coupled with latest technology.",
  },
];

const FeatureCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(4),
  textAlign: "center",
  transition: "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
  "&:hover": {
    transform: "scale(1.05)",
    boxShadow: theme.shadows[10],
  },
}));

export default function Features() {
  return (
    <Container sx={{ pt: { xs: 8 }, pb: { xs: 8, sm: 16 } }}>
      <Box sx={{ textAlign: "center", mb: 4 }}>
        <Typography component="h2" variant="h4" gutterBottom>
          Product Features
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Provide a brief overview of the key features of the product. For
          example, you could list the number of features, their types or
          benefits, and add-ons.
        </Typography>
      </Box>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "1fr 1fr 1fr" },
          gap: 4,
        }}
      >
        {items.map((item, index) => (
          <FeatureCard key={index}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 2,
              }}
            >
              {item.icon}
              <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                {item.title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {item.description}
              </Typography>
            </Box>
          </FeatureCard>
        ))}
      </Box>
    </Container>
  );
}
